module.exports = __webpack_public_path__ + "static/media/shared.1fb2791e.svg";